"use strict";
var slideIndex = 1;
showSlides(slideIndex);
function plusSlides(n) {
    showSlides(slideIndex += n);
}
function showSlides(n) {
    var i;
    var slides = document.getElementsByClassName("mySlides");
    if (slides.length === 0) return;
    if (n > slides.length) slideIndex = 1;
    if (n < 1) slideIndex = slides.length;
    for(i = 0; i < slides.length; i++)slides[i].style.display = "none";
    slides[slideIndex - 1].style.display = "block";
}
var element1 = document.getElementById("prev-img");
element1.addEventListener("click", function(e) {
    e.preventDefault();
    plusSlides(-1);
});
var element2 = document.getElementById("next-img");
element2.addEventListener("click", function(e) {
    e.preventDefault();
    plusSlides(1);
});

//# sourceMappingURL=index.48d45674.js.map
